import React, {useRef, useEffect, useState} from 'react'
import {isImage} from './extensions'

export const MediaAttachment = ({src, autoPlay = false, videoControls = true, muted = false, imageStyle = {}, onClick = () => {}, onLoad, className, preload = "metadata", isPreview, ...rest}) => {
  if (isImage(src)) {
    let image = new Image();
    image.src = src;
    return <img src={src} style={imageStyle} {...rest} onLoad={onLoad || (() => {})} onClick={(event) => {
      onClick({
        target: event.target, // A reference to the image, used for size validation
        width: image.width,
        height: image.height
      })
    }}/>;
  } else {
    const audio = new Audio(src);
    const videoTag = useRef(null);
    if(muted) {
      useEffect(() => {
        videoTag.current.muted = true;
      }, []);
    }
    return <div {...rest} className={`${isPreview ? "preview-video" : ""}`} onClick={(event) => {
      /*
       * Unfortunately, video metadata will only be there once the video has finished loading.
       * A person could select it before it loads.
       */
      onClick({
        width: event.target.videoWidth,
        height: event.target.videoHeight,
        duration: audio.duration
      })
    }}>
      {
      isPreview 
      ? 
        <div className={`preview-video-overlay`}>
          <i className="far fa-play-circle preview-video-icon fa-2x"></i>
        </div>
       : null}
      <video ref={videoTag} controls={videoControls} autoPlay={autoPlay} className={`${className ? className : ""}`} style={imageStyle} preload={preload}>
        <source src={src}/>
      </video>
    </div>
  }
};
